import { HttpClient, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, map, Observable } from 'rxjs'
import { AppConfigurationService } from '../../app-configuration.service'
import { SharedService } from '../../shared/shared.service'

@Injectable({
  providedIn: 'root'
})
export class ImageLibraryService {
  constructor(
    private http: HttpClient,
    private appConfigurationService: AppConfigurationService,
    private sharedService: SharedService
  ) {}

  public getImageLibraryByBrand(brand: string): Observable<any> {
    const baseUrl = this.appConfigurationService.getBaseSiteUrl()
    const url = `${baseUrl}/users/current/images/zip`
    const payload: HttpParams = new HttpParams().set('code', brand)

    return this.http.get(url, { params: payload }).pipe(
      map((res: any) => {
        return { url: this.sharedService.getMediaUrl(res?.downloadUrl), fileName: res.filename }
      }),
      catchError((error) => this.sharedService.handleError(error))
    )
  }
}
